import { render, staticRenderFns } from "./profileDataToUpgradeToCompany.vue?vue&type=template&id=2b2a3fa4"
import script from "./profileDataToUpgradeToCompany.vue?vue&type=script&lang=js"
export * from "./profileDataToUpgradeToCompany.vue?vue&type=script&lang=js"
import style0 from "./profileDataToUpgradeToCompany.vue?vue&type=style&index=0&id=2b2a3fa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports